module.exports = __webpack_public_path__ + "media/images/chat-alex-icon-a6553eba.svg";